import { assertUnreachable } from '@/utils';

import { Params, SearchableType } from '../../types';

import actionCreators from './action-creators';

export const initialState = {
  scopes: new Set(['team', 'product', 'capability'] as SearchableType[]),
  params: {} as Params,
};

type State = typeof initialState;
type Action = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'ADD_SCOPE': {
      const { scope } = action.payload;
      const scopes = new Set(state.scopes);
      scopes.add(scope);
      return { ...state, scopes };
    }
    case 'REMOVE_SCOPE': {
      const { scope } = action.payload;
      const scopes = new Set(state.scopes);
      scopes.delete(scope);
      return { ...state, scopes };
    }
    case 'ADD_PARAM': {
      const { scope, terms } = action.payload;

      const params = {
        ...state.params,
      };
      params[scope] = terms;

      /* NOTE: Remove scope from available scopes */
      const scopes = new Set(state.scopes);
      scopes.delete(scope);

      return { ...state, params, scopes };
    }
    case 'REMOVE_PARAM': {
      const { scope } = action.payload;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [scope]: removed, ...rest } = state.params;

      const scopes = new Set(state.scopes);
      scopes.add(scope);

      const params = rest as State['params'];

      return { ...state, params, scopes };
    }
    default: {
      return assertUnreachable(action);
    }
  }
}
